import { css } from '@emotion/react'

export const unstyledLinkStyles = css`
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
`
